export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8926.ae1fd7dc.jpg";